import { render, staticRenderFns } from "./PopupsManager.vue?vue&type=template&id=329423f4&"
import script from "./PopupsManager.vue?vue&type=script&lang=js&"
export * from "./PopupsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports